









































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import Toggle from '@/components/Toggle.vue';

@Component({
    components: {
        Toggle,
    },
})
export default class AdminNotificationPanel extends Mixins(InputFieldMethods) {
    public currentPassword: string = '';
    public newPassword: string = '';
    public repeatPassword: string = '';

    constructor() {
        super();
    }

    get staffNotifications(): any {
        return this.$store.getters['User/getStaffNotifications'];
    }

    get toggleTicketsNotification(): boolean {
        return this.staffNotifications.includes(0);
    }

    set toggleTicketsNotification(value: boolean) {
        this.staffNotifications.includes(0) ? this.removeNotification(0) : this.addNotification(0);
        return;
    }

    get toggleMessagesNotification(): boolean {
        return this.staffNotifications.includes(1);
    }

    set toggleMessagesNotification(value: boolean) {
        this.staffNotifications.includes(1) ? this.removeNotification(1) : this.addNotification(1);
        return;
    }

    get toggleDailyNotification(): boolean {
        return this.staffNotifications.includes(2);
    }

    set toggleDailyNotification(value: boolean) {
        this.staffNotifications.includes(2) ? this.removeNotification(2) : this.addNotification(2);
        return;
    }

    get toggleConversationsNotification(): boolean {
        return this.staffNotifications.includes(3);
    }

    set toggleConversationsNotification(value: boolean) {
        this.staffNotifications.includes(3) ? this.removeNotification(3) : this.addNotification(3);
        return;
    }

    public addNotification(value: any) {
        this.staffNotifications.push(value);
        this.$store.dispatch(Actions.TOGGLE_STAFF_NOTIFICATIONS, {value, action: 'add'});
    }

    public removeNotification(value: any) {
        const notifications = this.staffNotifications.filter((nt: any) => nt !== value);
        this.$store.commit(Mutations.SET_STAFF_NOTIFICATIONS, notifications);
        this.$store.dispatch(Actions.TOGGLE_STAFF_NOTIFICATIONS, {value, action: 'remove'});
    }

    public beforeCreate() {
        this.$store.dispatch(Actions.FETCH_STAFF_NOTIFICATIONS);
    }
}
